import { useState, useEffect, useRef } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink, useNavigate, NavLink, useParams, useLocation } from 'react-router-dom';
import { toast } from "react-toastify";
import TableToExcel from '@linways/table-to-excel';
import { useForm } from "react-hook-form";
import * as React from 'react';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box, Modal } from '@mui/material';
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import "bootstrap-icons/font/bootstrap-icons.css";
import '../common.scss';
import * as userActions from "../../actions/userActions";
import AccessDenied from '../common/AccessDenied';
import * as leadBankStatementActions from "../../actions/leadBankStatementActions";
import * as leadActions from "../../actions/leadActions";
// ----------------------------------------------------------------------
const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));
// ----------------------------------------------------------------------
const CustomerAssessmentNoteViewPage = (props) => {
 // const { leadId, id } = useParams();
  const location = useLocation();
  const {leadInfo, actions, usersData, fetchLeadIdBankStatement,formCAMValues,anchorCategories,speciallyAbledArr ,handleCAMChange,residenceTypesArr,bankingUpiArr,constitutionArr,customerTypeArr, vehicleMakerArr ,vehicleUseArr ,insuranceArr ,vehicleModelsArr ,camTotalPFAmount ,coapplicantGuarantorRows ,handleInputChange ,businessValidationProofArr ,turnoverIncomeArr ,workingCapitalCycleArr ,accountTypeArr ,requirementOptions ,statusOptions ,normsMetOptions,cAMLTVPercentage ,cAMMarginMoney,camIRRExcludingPF} = props;
  const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();
  const navigate = useNavigate(); 
  const [file, setFile] = useState('');
    
useEffect(() => {
 }, []);

 const downloadExcel = async () => {
             const table = document.getElementById('DynamicExcelFile');
     
             TableToExcel.convert(table, {
                 name: 'FI-Checklist.xlsx',
                 sheet: {
                     name: 'FI-Checklist',
                 },
             });
         };

  const [showEditDiv, setShowEditDiv] = useState(true);

  const handleToggle = () => {
    setShowEditDiv((prev) => !prev); 
  };    

  return (
    <>
      <div className="row" >

        <table className="table data_table table-bordered mt-5 table-hover mb-0" id="DynamicExcelFile"  data-cols-width="22,16,16,16,16,16,16,16,16,16" data-fill-color="#fff">
            <tbody>                            
                <tr>
                    <th colSpan="14" style={{ textAlign: 'center' }} data-f-bold="true">Section A : Basic Details</th>
                </tr>

                <tr>
                  <td colSpan="1" data-f-bold="true"><b>Customer Name :</b></td>
                  <td colSpan="1">{formCAMValues.cam_customer_name}</td>

                  <td colSpan="1" data-f-bold="true"><b>PAN No :</b></td>
                  <td colSpan="1" >{formCAMValues.cam_pan_no}</td>

                  <td colSpan="1" data-f-bold="true"><b>Category :</b></td>
                  <td colSpan="1" >{formCAMValues.cam_category}</td>

                  <td colSpan="1" data-f-bold="true"><b>Sales Manager :</b></td>
                  <td colSpan="1" >{formCAMValues.cam_sales_manager}</td>

                  <td colSpan="1" data-f-bold="true"><b>No. of Vehicles Owned :</b></td>
                  <td colSpan="1" >{formCAMValues.cam_no_of_vehicles_owned}</td>

                  <td colSpan="1" data-f-bold="true"><b>Gender :</b></td>
                  <td colSpan="1" >{formCAMValues.cam_gender}</td>

                  <td colSpan="1" data-f-bold="true"><b>Specially Abled :</b></td>
                  <td colSpan="1" >{formCAMValues.cam_specially_abled}</td>
              </tr>

              <tr>
                  <td colSpan="1" data-f-bold="true"><b>Contact Person Name & Designation :</b></td>
                  <td colSpan="1">{formCAMValues.cam_contact_person_name_designation}</td>

                  <td colSpan="1" data-f-bold="true"><b>Address :</b></td>
                  <td colSpan="1" >{formCAMValues.cam_address}</td>

                  <td colSpan="1" data-f-bold="true"><b>Mobile No. :</b></td>
                  <td colSpan="1" >{formCAMValues.cam_mobile_no}</td>

                  <td colSpan="1" data-f-bold="true"><b>Repayment Mode :</b></td>
                  <td colSpan="1" >{formCAMValues.cam_repayment_mode}</td>

                  <td colSpan="1" data-f-bold="true"><b>Credit Free Vehicle :</b></td>
                  <td colSpan="1" >{formCAMValues.cam_credit_free_vehicle}</td>

                  <td colSpan="1" data-f-bold="true"><b>Social Category :</b></td>
                  <td colSpan="1" >{formCAMValues.cam_social_category}</td>

                  <td colSpan="1" data-f-bold="true"><b>SPOUSE / Father Name :</b></td>
                  <td colSpan="1" >{formCAMValues.cam_spouse}</td>
              </tr>
  
              <tr>
                  <td colSpan="1" data-f-bold="true"><b>DOB :</b></td>
                  <td colSpan="1">{formCAMValues.cam_dob}</td>

                  <td colSpan="1" data-f-bold="true"><b>Cibil/ Crif :</b></td>
                  <td colSpan="1" >{formCAMValues.cam_cibil_crif}</td>

                  <td colSpan="1" data-f-bold="true"><b>Residence :</b></td>
                  <td colSpan="1" >{formCAMValues.cam_residence_type}</td>

                  <td colSpan="1" data-f-bold="true"><b>Current Address and City Stability :</b></td>
                  <td colSpan="1" >{formCAMValues.cam_current_address_and_city_stability}</td>

                  <td colSpan="1" data-f-bold="true"><b>Education :</b></td>
                  <td colSpan="1" >{formCAMValues.cam_education}</td>

                  <td colSpan="1" data-f-bold="true"><b>SOURCE :</b></td>
                  <td colSpan="1" >{formCAMValues.cam_source}</td>

                  <td colSpan="1" data-f-bold="true"><b>FILE CHARGES :</b></td>
                  <td colSpan="1" >{formCAMValues.cam_file_charges}</td>
              </tr>
              
              <tr>
                  <td colSpan="1" data-f-bold="true"><b>Kotak Li Amount :</b></td>
                  <td colSpan="1" >{formCAMValues.cam_kotak_li_amount}</td>  

                  <td colSpan="1" data-f-bold="true"><b>DL :</b></td>
                  <td colSpan="1" >{formCAMValues.cam_dl}</td> 

                  <td colSpan="1" data-f-bold="true"><b>Banking UPI & Cheques :</b></td>
                  <td colSpan="1" >{formCAMValues.cam_banking_upi}</td>

                  <td colSpan="1" data-f-bold="true"><b>Vehicle Use :</b></td>
                  <td colSpan="1" >{formCAMValues.cam_vehicle_use_open}</td>
              </tr>

            </tbody>  
        </table>
          <div className="row"> 


            <table className="table data_table table-bordered mt-5 table-hover mb-0" id="DynamicExcelFile"  data-cols-width="22,16,16,16,16,16,16,16,16,16" data-fill-color="#fff">
              <tbody>                            
                <tr>
                    <th colSpan="14" style={{ textAlign: 'center' }} data-f-bold="true">Assets Details :</th>
                </tr>
                
                <tr>
                  <td colSpan="3" data-f-bold="true"><b>Consolidated EMI :</b></td>
                  <td colSpan="3">{formCAMValues.cam_consolidated_emi}</td>

                  <td colSpan="4" data-f-bold="true"><b>E-Mail ID :</b></td>
                  <td colSpan="4">{formCAMValues.cam_email_id}</td>
                </tr>

                <tr>
                  <td colSpan="1" data-f-bold="true"><b>Constitution </b>:</td>
                  <td colSpan="1">{formCAMValues.cam_constitution}</td>

                  <td colSpan="1" data-f-bold="true"><b>Customer Type :</b></td>
                  <td colSpan="1">{formCAMValues.cam_customer_type}</td>

                  <td colSpan="1" data-f-bold="true"><b>Vehicle Maker :</b></td>
                  <td colSpan="1">{formCAMValues.cam_vehicle_maker}</td>

                  <td colSpan="1" data-f-bold="true"><b>EMI Per Vehicle :</b></td>
                  <td colSpan="1">{formCAMValues.cam_emi_per_vehicle}</td>

                  <td colSpan="1" data-f-bold="true"><b>Free Vehicle % :</b></td>
                  <td colSpan="1">{formCAMValues.cam_free_vehicle_percentage}</td>

                  <td colSpan="2" data-f-bold="true"><b>Additional Source of Income :</b></td>
                  <td colSpan="2">{formCAMValues.cam_additional_source_of_income}</td>
                </tr>

                <tr>
                  <td colSpan="1" data-f-bold="true"><b>Vehicle Use :</b></td>
                  <td colSpan="1">{formCAMValues.cam_vehicle_use}</td>

                  <td colSpan="1" data-f-bold="true"><b>Insurance :</b></td>
                  <td colSpan="1">{formCAMValues.cam_insurance}</td>

                  <td colSpan="1" data-f-bold="true"><b>Vehicle Model :</b></td>
                  <td colSpan="1">{formCAMValues.cam_vehicle_models}</td>

                  <td colSpan="1" data-f-bold="true"><b>Dealer Name :</b></td>
                  <td colSpan="1">{formCAMValues.cam_dealer_name}</td>

                  <td colSpan="1" data-f-bold="true"><b>Loan Tenor (in Months) :</b></td>
                  <td colSpan="1">{formCAMValues.cam_loan_tenor_in_months}</td>

                  <td colSpan="2" data-f-bold="true"><b>Payout :</b></td>
                  <td colSpan="2">{formCAMValues.cam_payout}</td>
                </tr>                
              </tbody>  
            </table>
  
 
            <table className="table data_table table-bordered mt-5 table-hover mb-0" id="DynamicExcelFile"  data-cols-width="22,16,16,16,16,16,16,16,16,16" data-fill-color="#fff">
              <tbody>                            
                <tr>
                    <th colSpan="14" style={{ textAlign: 'center' }} data-f-bold="true">Commercials </th>
                </tr>

                <tr>
                  <td colSpan="1" data-f-bold="true"><b>PF :</b></td>
                  <td colSpan="1">{formCAMValues.cam_pf}</td>

                  <td colSpan="1" data-f-bold="true"><b>IRR :</b></td>
                  <td colSpan="1" >{formCAMValues.cam_iarr}</td>

                  <td colSpan="1" data-f-bold="true"><b>Location :</b></td>
                  <td colSpan="1" >{formCAMValues.cam_location}</td>

                  <td colSpan="1" data-f-bold="true"><b>Asset Cost :</b></td>
                  <td colSpan="1" >{formCAMValues.cam_asset_cost}</td>

                  <td colSpan="1" data-f-bold="true"><b>No. of Asset :</b></td>
                  <td colSpan="1" >{formCAMValues.cam_no_of_asset}</td>

                  <td colSpan="1" data-f-bold="true"><b>Total Cost :</b></td>
                  <td colSpan="1" >{formCAMValues.cam_total_cost}</td>

                  <td colSpan="1" data-f-bold="true"><b>Finance Value :</b></td>
                  <td colSpan="1" >{formCAMValues.cam_finance_value}</td> 
                </tr>

                <tr>
                  <td colSpan="1" data-f-bold="true"><b>LTV :</b></td>
                  <td colSpan="1">{formCAMValues.cam_ltv}</td>

                  <td colSpan="1" data-f-bold="true"><b>Margin Money :</b></td>
                  <td colSpan="1" >{formCAMValues.cam_margin_money}</td>

                  <td colSpan="1" data-f-bold="true"><b>PF Amount :</b></td>
                  <td colSpan="1" >{formCAMValues.cam_pf_amount}</td>

                  <td colSpan="1" data-f-bold="true"><b>FLAT IRR :</b></td>
                  <td colSpan="1" >{formCAMValues.cam_flat_irr}</td>

                  <td colSpan="1" data-f-bold="true"><b>Addhar No :</b></td>
                  <td colSpan="1" >{formCAMValues.cam_addhar_no}</td>
                </tr>

              </tbody>  
            </table>

            <table className="table data_table table-bordered mt-5 table-hover mb-0" id="DynamicExcelFile"  data-cols-width="22,16,16,16,16,16,16,16,16,16" data-fill-color="#fff">

            <tbody>
              <tr>
                <th colSpan="14" style={{ textAlign: 'center' }} data-f-bold="true">
                  Section B : Other's Details (Need to display the accepted records - Approved from credit team)
                </th>
              </tr>
              {coapplicantGuarantorRows.map((row, index) => {
                const isCoApplicant = row.type === 'Co-Applicant';
                const isGuarantor = row.type === 'Guarantors';

                return (
                  <React.Fragment key={row.id}>
                    <tr>
                      <th colSpan="14" style={{ textAlign: 'center' }} data-f-bold="true">
                        {row.type}
                      </th>
                    </tr>
                    <tr>
                      <td colSpan="2" data-f-bold="true"><b>Company/Proprietor /Partner/Director/{isCoApplicant ? 'Co applicant' : 'Guarantor'} :</b></td>
                      <td colSpan="3">{row.name}</td>
                      <td colSpan="1" data-f-bold="true"><b>PAN No. :</b></td>
                      <td colSpan="3">{row.pan_number}</td>
                      <td colSpan="2" data-f-bold="true"><b>Father Name :</b></td>
                      <td colSpan="3">{row.father_name}</td>
                    </tr>
                    <tr>
                      <td colSpan="2" data-f-bold="true"><b>Aadhar No. :</b></td>
                      <td colSpan="3">{row.adhar_number}</td>
                      <td colSpan="1" data-f-bold="true"><b>Age :</b></td>
                      <td colSpan="3">{row.dob}</td>
                      <td colSpan="2" data-f-bold="true"><b>Position/Relationship :</b></td>
                      <td colSpan="3">{row.relation}</td>
                    </tr>
                    <tr>
                      <td colSpan="2" data-f-bold="true"><b>Current Address :</b></td>
                      <td colSpan="12">{row.full_address}</td>
                    </tr>
                    <tr>
                      <td colSpan="2" data-f-bold="true"><b>Permanent Address :</b></td>
                      <td colSpan="3">{row.permanent_address}</td>
                      <td colSpan="1" data-f-bold="true"><b>Office Address :</b></td>
                      <td colSpan="3">{row.office_address}</td>
                      <td colSpan="2" data-f-bold="true"><b>Contact No. :</b></td>
                      <td colSpan="3">{row.mobile}</td>
                    </tr>
                    <tr>
                      <td colSpan="2" data-f-bold="true"><b>Reference Details :</b></td>
                      <td colSpan="3">{row.reference_details}</td>
                      <td colSpan="1" data-f-bold="true"><b>Bureau Score :</b></td>
                      <td colSpan="3">{row.crif_score}</td>
                      <td colSpan="2" data-f-bold="true"><b>Education/Experience / Bureau Remarks :</b></td>
                      <td colSpan="3">{row.bureau_remarks}</td>
                    </tr>
                  </React.Fragment>
                );
              })}
            </tbody>


              {/* <tbody>
                <tr>
                  <th colSpan="14" style={{ textAlign: 'center' }} data-f-bold="true">
                    Section B : Other's Details (Need to display the accepted records - Approved from credit team)
                  </th>
                </tr>

                <tr>
                  <td colSpan="2" data-f-bold="true"><b>Company/Proprietor /Partner/Director/Co applicant / Guarantor Name :</b></td>
                  <td colSpan="3">
                    {coapplicantGuarantorRows.map((row, index) => (
                      <React.Fragment key={index}>
                        {row.name}
                        <br />
                      </React.Fragment>
                    ))}
                  </td>

                  <td colSpan="1" data-f-bold="true"><b>PAN No. :</b></td>
                  <td colSpan="3">
                    {coapplicantGuarantorRows.map((row, index) => (
                      <React.Fragment key={index}>
                        {row.pan_number}
                        <br />
                      </React.Fragment>
                    ))}
                  </td>

                  <td colSpan="2" data-f-bold="true"><b>Father Name :</b></td>
                  <td colSpan="3">
                    {coapplicantGuarantorRows.map((row, index) => (
                      <React.Fragment key={index}>
                        {row.father_name}
                        <br />
                      </React.Fragment>
                    ))}
                  </td>
                </tr>

                <tr>
                  <td colSpan="2" data-f-bold="true"><b>Aadhar No. :</b></td>
                  <td colSpan="3">
                    {coapplicantGuarantorRows.map((row, index) => (
                      <React.Fragment key={index}>
                        {row.adhar_number}
                        <br />
                      </React.Fragment>
                    ))}
                  </td>

                  <td colSpan="1" data-f-bold="true"><b>Age :</b></td>
                  <td colSpan="3">
                    {coapplicantGuarantorRows.map((row, index) => (
                      <React.Fragment key={index}>
                        {row.dob}
                        <br />
                      </React.Fragment>
                    ))}
                  </td>

                  <td colSpan="2" data-f-bold="true"><b>Position/Relationship :</b></td>
                  <td colSpan="3">
                    {coapplicantGuarantorRows.map((row, index) => (
                      <React.Fragment key={index}>
                        {row.relation}
                        <br />
                      </React.Fragment>
                    ))}
                  </td>
                </tr>

                <tr>
                  <td colSpan="2" data-f-bold="true"><b>Current Address :</b></td>
                  <td colSpan="12">
                    {coapplicantGuarantorRows.map((row, index) => (
                      <React.Fragment key={index}>
                        {row.full_address}
                        <br />
                      </React.Fragment>
                    ))}
                  </td>
                </tr>

                <tr>
                  <td colSpan="2" data-f-bold="true"><b>Permanent Address :</b></td>
                  <td colSpan="3">
                    {coapplicantGuarantorRows.map((row, index) => (
                      <React.Fragment key={index}>
                        {row.permanent_address}
                        <br />
                      </React.Fragment>
                    ))}
                  </td>

                  <td colSpan="1" data-f-bold="true"><b>Office Address :</b></td>
                  <td colSpan="3">
                    {coapplicantGuarantorRows.map((row, index) => (
                      <React.Fragment key={index}>
                        {row.office_address}
                        <br />
                      </React.Fragment>
                    ))}
                  </td>

                  <td colSpan="2" data-f-bold="true"><b>Contact No. :</b></td>
                  <td colSpan="3">
                    {coapplicantGuarantorRows.map((row, index) => (
                      <React.Fragment key={index}>
                        {row.mobile}
                        <br />
                      </React.Fragment>
                    ))}
                  </td>
                </tr>

                <tr>
                  <td colSpan="2" data-f-bold="true"><b>Reference Details :</b></td>
                  <td colSpan="3">
                    {coapplicantGuarantorRows.map((row, index) => (
                      <React.Fragment key={index}>
                        {row.reference_details}
                        <br />
                      </React.Fragment>
                    ))}
                  </td>

                  <td colSpan="1" data-f-bold="true"><b>Bureau Score :</b></td>
                  <td colSpan="3">
                    {coapplicantGuarantorRows.map((row, index) => (
                      <React.Fragment key={index}>
                        {row.crif_score}
                        <br />
                      </React.Fragment>
                    ))}
                  </td>

                  <td colSpan="2" data-f-bold="true"><b>Education/Experience / Bureau Remarks :</b></td>
                  <td colSpan="3">
                    {coapplicantGuarantorRows.map((row, index) => (
                      <React.Fragment key={index}>
                        {row.bureau_remarks}
                        <br />
                      </React.Fragment>
                    ))}
                  </td>
                </tr>
              </tbody> */}


                

            </table>
    
                {/* <div className="col-md-12" >
                <div className='form-group' >
                  <hr/>
                      <h5 className='text-center text-primary'>Section B: Other's  Details (Need to display the accepted records  - Approved from credit team)</h5>
                  <hr/>
                </div>
                </div>
                <div className="col-md-12" >
                  <table border="1" className="table">
                          <thead>
                            <tr>
                              <th>Company/Proprietor /Partner/Director/Co applicant / Guarantor Name</th>
                              <th>PAN No.</th>
                              <th>Father Name</th>
                              <th>Aadhar No.</th>
                              <th>Age</th>
                              <th>Position/Relationship</th>
                              <th>Current Address</th>
                              <th>Permanent Address</th>
                              <th>Office Address</th>
                              <th>Contact No.</th>
                              <th>Reference Details</th>
                              <th>Bureau Score</th>
                              <th>Education/Experience / Bureau Remarks</th>
                            </tr>
                          </thead>
                          <tbody>
                            {console.log("IM CHECKING ONLY FEW DETAILS ", coapplicantGuarantorRows)}
                            {coapplicantGuarantorRows.map((row, index) => (
                              <tr key={index}>
                                <td> 
                                  <input
                                    type="text"
                                    className='form-control'
                                    value={row.name}
                                    onChange={(e) => handleInputChange(row.id, "name", e.target.value)}
                                    readOnly='true'
                                  />
                                </td>
                                <td>
                                <input
                                    type="text"
                                    className='form-control'
                                    value={row.pan_number}
                                    onChange={(e) => handleInputChange(row.id, "pan_number", e.target.value)}
                                    readOnly='true'
                                  />
                
                                </td>
                                <td>
                                  
                                <input
                                    type="text"
                                    className='form-control'
                                    value={row.father_name}
                                    onChange={(e) => handleInputChange(row.id, "father_name", e.target.value)}
                                    
                                  />
                                </td>
                                <td>
                                  
                                <input
                                    type="text"
                                    className='form-control'
                                    value={row.adhar_number}
                                    onChange={(e) => handleInputChange(row.id, "adhar_number", e.target.value)}
                                    readOnly='true'
                                  />
                                </td>
                                <td>
                                  
                                <input
                                    type="date"
                                    className='form-control'
                                    value={row.dob}
                                    onChange={(e) => handleInputChange(row.id, "dob", e.target.value)}
                                    readOnly='true'
                                  />
                                </td>
                                <td>
                                  
                                <input
                                    type="text"
                                    className='form-control'
                                    value={row.relation}
                                    onChange={(e) => handleInputChange(row.id, "relation", e.target.value)}
                                      
                                  />
                                </td>
                                <td>
                                  
                                <input
                                    type="text"
                                    className='form-control'
                                    value={row.full_address}
                                    onChange={(e) => handleInputChange(row.id, "full_address", e.target.value)}
                                      
                                  />
                                </td>
                                <td>
                                  
                                <input
                                    type="text"
                                    className='form-control'
                                    value={row.permanent_address}
                                    onChange={(e) => handleInputChange(row.id, "permanent_address", e.target.value)}
                                    
                                  />
                                </td>
                
                                <td>
                                  
                                  <input
                                      type="text"
                                      className='form-control'
                                      value={row.office_address}
                                      onChange={(e) => handleInputChange(row.id, "office_address", e.target.value)}
                                      
                                    />
                                  </td>
                  
                
                                <td>
                                <input
                                    type="text"
                                    className='form-control'
                                    value={row.mobile}
                                    onChange={(e) => handleInputChange(row.id, "mobile", e.target.value)}
                                    
                                  />
                                </td>
                                
                                <td>
                                <input
                                    type="text"
                                    className='form-control'
                                    value={row.reference_details}
                                    onChange={(e) => handleInputChange(row.id, "reference_details", e.target.value)}
                                    
                                  />
                                </td>
                                <td>
                                <input
                                    type="text"
                                    className='form-control'
                                    value={row.crif_score}
                                    onChange={(e) => handleInputChange(row.id, "crif_score", e.target.value)}
                                    readOnly="true"
                                  />
                
                                </td>
                                <td> 
                                <input
                                    type="text"
                                    className='form-control'
                                    value={row.bureau_remarks}
                                    onChange={(e) => handleInputChange(row.id, "bureau_remarks", e.target.value)}
                                    
                                  />
                                </td> 
                              </tr>
                            ))}
                          </tbody>
                        </table>
                </div> */}

            {/* Profile Details Start Here */}

            <table className="table data_table table-bordered mt-5 table-hover mb-0" id="DynamicExcelFile"  data-cols-width="22,16,16,16,16,16,16,16,16,16" data-fill-color="#fff">
              <tbody>                            
                <tr>
                    <th colSpan="14" style={{ textAlign: 'center' }} data-f-bold="true">Profile Details :</th>
                </tr>
                <tr>
                    <th colSpan="14" style={{ textAlign: 'left' }} data-f-bold="true">Remarks</th>
                </tr>   

                <tr>
                    <th colSpan="14" style={{ textAlign: 'left' }} data-f-bold="true">{formCAMValues.remark_business_detail}</th>
                </tr>   
              </tbody>  
            </table>


            {/* Profile Details End Here */}

            <table className="table data_table table-bordered mt-5 table-hover mb-0" id="DynamicExcelFile"  data-cols-width="22,16,16,16,16,16,16,16,16,16" data-fill-color="#fff">
              <tbody>                            
                <tr>
                    <th colSpan="14" style={{ textAlign: 'center' }} data-f-bold="true">Section C: REMARKS/COMMENTS </th>
                </tr>

                <tr>
                    <th colSpan="14" style={{ textAlign: 'left' }} data-f-bold="true">Particulars : </th>
                </tr>

                <tr>
                  <td colSpan="2" data-f-bold="true"><b>Business profile and Business model :</b></td>
                  <td colSpan="2">{formCAMValues.remarks_business_profile}</td>

                  <td colSpan="2" data-f-bold="true"><b>Major Activity :</b></td>
                  <td colSpan="2" >{formCAMValues.remarks_major_activity}</td>

                  <td colSpan="2" data-f-bold="true"><b>Business Vintage :</b></td>
                  <td colSpan="2" >{formCAMValues.remarks_business_vintage}</td>

                  <td colSpan="1" data-f-bold="true"><b>Business Validation Proof :</b></td>
                  <td colSpan="1" >{formCAMValues.remarks_business_validation_proof}</td>
                </tr>

                <tr>
                    <th colSpan="14" style={{ textAlign: 'left' }} data-f-bold="true">Customer Due Diligence Check and Comments : </th>
                </tr>

                <tr>
                  <td colSpan="2" data-f-bold="true"><b>Turnover / Income :</b></td>
                  <td colSpan="2">{formCAMValues.remarks_turnover_income}</td>

                  <td colSpan="2" data-f-bold="true"><b>Working capital Cycle :</b></td>
                  <td colSpan="2" >{formCAMValues.remarks_working_capital_cycle}</td>

                  <td colSpan="1" data-f-bold="true"><b>Credit Bureau Remarks (Commercial If Done) :</b></td>
                  <td colSpan="1" >{formCAMValues.remarks_credit_bureau_remarks_commercial}</td>

                  <td colSpan="2" data-f-bold="true"><b>Work Order / Contracts :</b></td>
                  <td colSpan="2" >{formCAMValues.remarks_work_order_contracts}</td>
                </tr>

                <tr>
                    <th colSpan="14" style={{ textAlign: 'left' }} data-f-bold="true"><b>Banking : </b></th>
                </tr>

                <tr>
                  <td colSpan="1" data-f-bold="true"><b>Bank Name :</b></td>
                  <td colSpan="1">{formCAMValues.remarks_bank_name}</td>

                  <td colSpan="1" data-f-bold="true"><b>A/c No :</b></td>
                  <td colSpan="1" >{formCAMValues.remarks_account_no}</td>

                  <td colSpan="1" data-f-bold="true"><b>IFSC Code :</b></td>
                  <td colSpan="1" >{formCAMValues.remarks_ifsc_code}</td>

                  <td colSpan="1" data-f-bold="true"><b>Type of Account :</b></td>
                  <td colSpan="1" >{formCAMValues.remarks_type_of_account}</td>

                  <td colSpan="1" data-f-bold="true"><b>ABB / Utilization :</b></td>
                  <td colSpan="1" >{formCAMValues.remarks_abb_utilization}</td>

                  <td colSpan="1" data-f-bold="true"><b>Total Credits :</b></td>
                  <td colSpan="1" >{formCAMValues.remarks_total_credits}</td>

                  <td colSpan="1" data-f-bold="true"><b>I/W Rtn % and count :</b></td>
                  <td colSpan="1" >{formCAMValues.remarks_iw_rtn_per_and_count}</td>
                </tr>

                <tr>
                  <td colSpan="1" data-f-bold="true"><b>O/W Rtn % and count :</b></td>
                  <td colSpan="1">{formCAMValues.remarks_ow_rtn_per_and_count}</td>

                  <td colSpan="3" data-f-bold="true"><b>Remarks :</b></td>
                  <td colSpan="3" >{formCAMValues.remarks_notes}</td>

                  <td colSpan="3" data-f-bold="true"><b>Previous EM-II/ UAM :</b></td>
                  <td colSpan="3" >{formCAMValues.remarks_previous_em_ii_uam}</td>
                </tr>

                <tr>
                  <td colSpan="4" data-f-bold="true"><b>Existing Loan Details (Remarks) :</b></td>
                  <td colSpan="10">{formCAMValues.remarks_existing_loan_details}</td>
                </tr>
                <tr>
                  <td colSpan="4" data-f-bold="true"><b>Credit Bureau Remarks :</b></td>
                  <td colSpan="10" >{formCAMValues.remarks_credit_bureau_remarks}</td>
                </tr>
                <tr>
                  <td colSpan="4" data-f-bold="true"><b>Current Vehicle Deployment - Load and Routes :</b></td>
                  <td colSpan="10" >{formCAMValues.remarks_current_vehicle_deployment}</td>
                </tr>
                <tr>
                  <td colSpan="4" data-f-bold="true"><b>Financials Related Remark :</b></td>
                  <td colSpan="10" >{formCAMValues.remarks_financials_related_remark}</td>
                </tr>
              </tbody>  
            </table>

            <table className="table data_table table-bordered mt-5 table-hover mb-0" id="DynamicExcelFile"  data-cols-width="22,16,16,16,16,16,16,16,16,16" data-fill-color="#fff">
                <tbody>                            
                  <tr>
                      <th colSpan="14" style={{ textAlign: 'center' }} data-f-bold="true">Section D: Due Dilligence and Onboarding checks </th>
                  </tr>

                  <tr>
                      <th colSpan="4" style={{ textAlign: 'center' }} data-f-bold="true">Particulars/Report</th>
                      <th colSpan="3" style={{ textAlign: 'center' }} data-f-bold="true">Requirement</th>
                      <th colSpan="3" style={{ textAlign: 'center' }} data-f-bold="true">Status</th>
                      <th colSpan="4" style={{ textAlign: 'center' }} data-f-bold="true">Remarks</th>
                  </tr>

                  <tr>
                    <td colSpan="4" data-f-bold="true"><b>Personal Discussion (PD)</b></td>
                    <td colSpan="3">{formCAMValues.dilligence_pd_requirement === "Applicable" ? "Applicable" : "Not Applicable"}</td>
                    {/* <td colSpan="3" >{formCAMValues.dilligence_pd_status === "Applicable" ? "Applicable" : "Not Applicable"}</td> */}
                    <td colSpan="3">{formCAMValues.dilligence_pd_status === "Applicable" || !formCAMValues.dilligence_pd_status ? "Applicable": "Not Applicable"}</td>

                    <td colSpan="4" >{formCAMValues.dilligence_pd_remarks}</td>
                  </tr>   

                  <tr>
                    <td colSpan="4" data-f-bold="true"><b>Proforma Invoice</b></td>
                    <td colSpan="3">{formCAMValues.dilligence_proformainvoice_requirement === "Applicable" ? "Applicable" : "Not Applicable"}</td>
                    {/* <td colSpan="3" >{formCAMValues.dilligence_proformainvoice_status === "Applicable" ? "Applicable" : "Not Applicable"}</td> */}
                    <td colSpan="3">{formCAMValues.dilligence_proformainvoice_status === "Applicable" || !formCAMValues.dilligence_proformainvoice_status ? "Applicable": "Not Applicable"}</td>
                    <td colSpan="4" >{formCAMValues.dilligence_proformainvoice_remarks}</td>
                  </tr>   

                  <tr>
                    <td colSpan="4" data-f-bold="true"><b>KYC</b></td>
                    <td colSpan="3">{formCAMValues.dilligence_kyc_requirement === "Applicable" ? "Applicable" : "Not Applicable"}</td>
                    {/* <td colSpan="3" >{formCAMValues.dilligence_kyc_status === "Applicable" ? "Applicable" : "Not Applicable"}</td> */}
                    <td colSpan="3">{formCAMValues.dilligence_kyc_status === "Applicable" || !formCAMValues.dilligence_kyc_status ? "Applicable": "Not Applicable"}</td>
                    <td colSpan="4" >{formCAMValues.dilligence_kyc_remarks}</td>
                  </tr>

                  <tr>
                    <td colSpan="4" data-f-bold="true"><b>Banking</b></td>
                    <td colSpan="3">{formCAMValues.dilligence_banking_requirement === "Applicable" ? "Applicable" : "Not Applicable"}</td>
                    {/* <td colSpan="3" >{formCAMValues.dilligence_banking_status === "Applicable" ? "Applicable" : "Not Applicable"}</td> */}
                    <td colSpan="3">{formCAMValues.dilligence_banking_status === "Applicable" || !formCAMValues.dilligence_banking_status ? "Applicable": "Not Applicable"}</td>
                    <td colSpan="4" >{formCAMValues.dilligence_banking_remarks}</td>
                  </tr>

                  <tr>
                    <td colSpan="4" data-f-bold="true"><b>GST</b></td>
                    <td colSpan="3">{formCAMValues.dilligence_gst_requirement === "Applicable" ? "Applicable" : "Not Applicable"}</td>
                    {/* <td colSpan="3" >{formCAMValues.dilligence_gst_status === "Not Applicable" ? "Applicable" : "Applicable"}</td> */}
                    <td colSpan="3">{formCAMValues.dilligence_gst_status === "Applicable" || !formCAMValues.dilligence_gst_status ? "Applicable": "Not Applicable"}</td>
                    <td colSpan="4" >{formCAMValues.dilligence_gst_remarks}</td>
                  </tr>        

                  <tr>
                    <td colSpan="4" data-f-bold="true"><b>Financials</b></td>
                    <td colSpan="3">{formCAMValues.dilligence_financials_requirement === "Applicable" ? "Applicable" : "Not Applicable"}</td>
                    {/* <td colSpan="3" >{formCAMValues.dilligence_financials_status === "Applicable" ? "Applicable" : "Not Applicable"}</td> */}
                    <td colSpan="3">{formCAMValues.dilligence_financials_status === "Applicable" || !formCAMValues.dilligence_financials_status ? "Applicable": "Not Applicable"}</td>
                    <td colSpan="4" >{formCAMValues.dilligence_financials_remarks}</td>
                  </tr>         
                </tbody>  
            </table>

    
            <table className="table data_table table-bordered mt-5 table-hover mb-0" id="DynamicExcelFile"  data-cols-width="22,16,16,16,16,16,16,16,16,16" data-fill-color="#fff">
              <tbody>                            
                <tr>
                    <th colSpan="14" style={{ textAlign: 'center' }} data-f-bold="true">Section E: Selection Criteria / Deviations</th>
                </tr>

                <tr>
                    <th colSpan="3" style={{ textAlign: 'center' }} data-f-bold="true">Parameters</th>
                    <th colSpan="2" style={{ textAlign: 'center' }} data-f-bold="true">Brand (N) / Distributor(N-1) - Standard criteria</th>
                    <th colSpan="2" style={{ textAlign: 'center' }} data-f-bold="true">Norms Met/Not Met</th>
                    <th colSpan="3" style={{ textAlign: 'center' }} data-f-bold="true">Deviation</th>
                    <th colSpan="2" style={{ textAlign: 'center' }} data-f-bold="true">Deviation Approval</th>
                    <th colSpan="2" style={{ textAlign: 'center' }} data-f-bold="true">Mitigation (If Norms not met)</th>
                </tr>

                <tr>
                  <td colSpan="3" data-f-bold="true"><b>Negative Profile Check</b> </td>
                  <td colSpan="2">{formCAMValues.dp_npc_standard_criteria}</td>
                  {/* <td colSpan="2" >{formCAMValues.dilligence_pd_status}</td> */}
                  <td colSpan="2">
                    {Number(formCAMValues.dp_npc_norms) === 1 ? "Met" :
                    Number(formCAMValues.dp_npc_norms) === 2 ? "Not Met" :
                    Number(formCAMValues.dp_npc_norms) === 3 ? "NA" :
                    formCAMValues.dp_npc_norms || "Not Available"}
                  </td>


                  <td colSpan="3" ><b>Negative Profile Check</b> </td>
                  <td colSpan="2" >{formCAMValues.dp_npc_deviation_approval}</td>
                  <td colSpan="2" >{formCAMValues.dp_npc_mitigation}</td>
                </tr>   

                <tr>
                  <td colSpan="3" data-f-bold="true"><b>Credit Free Vehicle in fleet</b> </td>
                  <td colSpan="2">{formCAMValues.dp_cfvif_standard_criteria}</td>
                  {/* <td colSpan="2" >{formCAMValues.dp_cfvif_norms}</td> */}

                  <td colSpan="2">
                    {Number(formCAMValues.dp_cfvif_norms) === 1 ? "Met" :
                    Number(formCAMValues.dp_cfvif_norms) === 2 ? "Not Met" :
                    Number(formCAMValues.dp_cfvif_norms) === 3 ? "NA" :
                    formCAMValues.dp_cfvif_norms || "Not Available"}
                  </td>



                  <td colSpan="3" ><b>Deviation allowed upto 0% subject to mitigants (income, RTR)</b> </td>
                  <td colSpan="2" >{formCAMValues.dp_cfvif_deviation_approval}</td>
                  <td colSpan="2" >{formCAMValues.dp_cfvif_mitigation}</td>
                </tr>   

                <tr>
                  <td colSpan="3" data-f-bold="true"><b>Asset Income Expense viability  / Cost Rationalisation (In case of Captive Use) and FOIR Check</b> </td>
                  <td colSpan="2">{formCAMValues.dp_aievcr_standard_criteria}</td>
                  {/* <td colSpan="2" >{formCAMValues.dp_aievcr_norms}</td> */}

                  <td colSpan="2">
                    {Number(formCAMValues.dp_aievcr_norms) === 1 ? "Met" :
                    Number(formCAMValues.dp_aievcr_norms) === 2 ? "Not Met" :
                    Number(formCAMValues.dp_aievcr_norms) === 3 ? "NA" :
                    formCAMValues.dp_aievcr_norms || "Not Available"}
                  </td>

                  <td colSpan="3" ><b>No Deviation Allowed</b> </td>
                  <td colSpan="2" >{formCAMValues.dp_aievcr_deviation_approval}</td>
                  <td colSpan="2" >{formCAMValues.dp_aievcr_mitigation}</td>
                </tr>   

                <tr>
                  <td colSpan="3" data-f-bold="true"><b>Maximum LTV</b> </td>
                  <td colSpan="2">{formCAMValues.dp_maxltv_standard_criteria}</td>
                  {/* <td colSpan="2" >{formCAMValues.dp_maxltv_norms}</td> */}
                  <td colSpan="2">
                    {Number(formCAMValues.dp_maxltv_norms) === 1 ? "Met" :
                    Number(formCAMValues.dp_maxltv_norms) === 2 ? "Not Met" :
                    Number(formCAMValues.dp_maxltv_norms) === 3 ? "NA" :
                    formCAMValues.dp_maxltv_norms || "Not Available"}
                  </td>

                  <td colSpan="3" ><b>Upto 93%</b> </td>
                  <td colSpan="2" >{formCAMValues.dp_maxltv_deviation_approval}</td>
                  <td colSpan="2" >{formCAMValues.dp_maxltv_mitigation}</td>
                </tr>   

                <tr>
                  <td colSpan="3" data-f-bold="true"><b>Stability (time in city)</b> </td>
                  <td colSpan="2">{formCAMValues.dp_stabilitytic_standard_criteria}</td>
                  {/* <td colSpan="2" >{formCAMValues.dp_stabilitytic_norms}</td> */}
                  <td colSpan="2">
                    {Number(formCAMValues.dp_stabilitytic_norms) === 1 ? "Met" :
                    Number(formCAMValues.dp_stabilitytic_norms) === 2 ? "Not Met" :
                    Number(formCAMValues.dp_stabilitytic_norms) === 3 ? "NA" :
                    formCAMValues.dp_stabilitytic_norms || "Not Available"}
                  </td>

                  <td colSpan="3" ><b>No Deviation Allowed</b> </td>
                  <td colSpan="2" >{formCAMValues.dp_stabilitytic_deviation_approval}</td>
                  <td colSpan="2" >{formCAMValues.dp_stabilitytic_mitigation}</td>
                </tr>         

                <tr>
                  <td colSpan="3" data-f-bold="true"><b>Property Ownership/ Stability</b> </td>
                  <td colSpan="2">{formCAMValues.dp_pwstability_standard_criteria}</td>
                  {/* <td colSpan="2" >{formCAMValues.dp_pwstability_norms}</td> */}
                  <td colSpan="2">
                    {Number(formCAMValues.dp_pwstability_norms) === 1 ? "Met" :
                    Number(formCAMValues.dp_pwstability_norms) === 2 ? "Not Met" :
                    Number(formCAMValues.dp_pwstability_norms) === 3 ? "NA" :
                    formCAMValues.dp_pwstability_norms || "Not Available"}
                  </td>
                  <td colSpan="3" ><b>Deviation Allowed for Rented Premises</b> </td>
                  <td colSpan="2" >{formCAMValues.dp_pwstability_deviation_approval}</td>
                  <td colSpan="2" >{formCAMValues.dp_pwstability_mitigation}</td>
                </tr>     

                 <tr>
                  <td colSpan="3" data-f-bold="true"><b>Required Co Applicant / Guarantor on Loan Structure</b> </td>
                  <td colSpan="2">{formCAMValues.dp_rcpgls_standard_criteria}</td>
                  {/* <td colSpan="2" >{formCAMValues.dp_rcpgls_norms}</td> */}
                  <td colSpan="2">
                    {Number(formCAMValues.dp_rcpgls_norms) === 1 ? "Met" :
                    Number(formCAMValues.dp_rcpgls_norms) === 2 ? "Not Met" :
                    Number(formCAMValues.dp_rcpgls_norms) === 3 ? "NA" :
                    formCAMValues.dp_rcpgls_norms || "Not Available"}
                  </td>
                  <td colSpan="3" ><b>No Deviation Allowed</b> </td>
                  <td colSpan="2" >{formCAMValues.dp_rcpgls_deviation_approval}</td>
                  <td colSpan="2" >{formCAMValues.dp_rcpgls_mitigation}</td>
                </tr>   

                 <tr>
                  <td colSpan="3" data-f-bold="true"><b>Business Stability / Driving Experience</b> </td>
                  <td colSpan="2">{formCAMValues.dp_bsde_standard_criteria}</td>
                  {/* <td colSpan="2" >{formCAMValues.dp_bsde_norms}</td> */}
                  <td colSpan="2">
                    {Number(formCAMValues.dp_bsde_norms) === 1 ? "Met" :
                    Number(formCAMValues.dp_bsde_norms) === 2 ? "Not Met" :
                    Number(formCAMValues.dp_bsde_norms) === 3 ? "NA" :
                    formCAMValues.dp_bsde_norms || "Not Available"}
                  </td>

                  <td colSpan="3" ><b>Deviation allowed upto 1 year - Business Stability For FTU /DCO - No deviation allowed on DL experience</b> </td>
                  <td colSpan="2" >{formCAMValues.dp_bsde_deviation_approval}</td>
                  <td colSpan="2" >{formCAMValues.dp_bsde_mitigation}</td>
                </tr>   

                 <tr>
                  <td colSpan="3" data-f-bold="true"><b>Net Worth</b> </td>
                  <td colSpan="2">{formCAMValues.dp_nw_standard_criteria}</td>
                  {/* <td colSpan="2" >{formCAMValues.dp_nw_norms}</td> */}
                  <td colSpan="2">
                    {Number(formCAMValues.dp_nw_norms) === 1 ? "Met" :
                    Number(formCAMValues.dp_nw_norms) === 2 ? "Not Met" :
                    Number(formCAMValues.dp_nw_norms) === 3 ? "NA" :
                    formCAMValues.dp_nw_norms || "Not Available"}
                  </td>

                  <td colSpan="3" ><b>Deviation allowed subject to positive cash profit</b> </td>
                  <td colSpan="2" >{formCAMValues.dp_dc_deviation_approval}</td>
                  <td colSpan="2" >{formCAMValues.dp_dc_mitigation}</td>
                </tr>   

                 <tr>
                  <td colSpan="3" data-f-bold="true"><b>Dedupe Checks</b> </td>
                  <td colSpan="2">{formCAMValues.dp_dc_standard_criteria}</td>
                  {/* <td colSpan="2" >{formCAMValues.dp_dc_norms}</td> */}
                  <td colSpan="2">
                    {Number(formCAMValues.dp_dc_norms) === 1 ? "Met" :
                    Number(formCAMValues.dp_dc_norms) === 2 ? "Not Met" :
                    Number(formCAMValues.dp_dc_norms) === 3 ? "NA" :
                    formCAMValues.dp_dc_norms || "Not Available"}
                  </td>

                  <td colSpan="3" ><b>No Deviation Allowed</b> </td>
                  <td colSpan="2" >{formCAMValues.dp_dc_deviation_approval}</td>
                  <td colSpan="2" >{formCAMValues.dp_dc_mitigation}</td>
                </tr>   

                 <tr>
                  <td colSpan="3" data-f-bold="true"><b>Bureau Check</b> </td>
                  <td colSpan="2">{formCAMValues.dp_bureaucheck_standard_criteria}</td>
                  {/* <td colSpan="2" >{formCAMValues.dp_bureaucheck_norms}</td> */}
                  <td colSpan="2">
                    {Number(formCAMValues.dp_bureaucheck_norms) === 1 ? "Met" :
                    Number(formCAMValues.dp_bureaucheck_norms) === 2 ? "Not Met" :
                    Number(formCAMValues.dp_bureaucheck_norms) === 3 ? "NA" :
                    formCAMValues.dp_bureaucheck_norms || "Not Available"}
                  </td>

                  <td colSpan="3" ><b>No Deviation Allowed</b> </td>
                  <td colSpan="2" >{formCAMValues.dp_bureaucheck_deviation_approval}</td>
                  <td colSpan="2" >{formCAMValues.dp_bureaucheck_mitigation}</td>
                </tr>   

                 <tr>
                  <td colSpan="3" data-f-bold="true"><b>Banking Criteria</b> </td>
                  <td colSpan="2">{formCAMValues.dp_bankingcriteria_standard_criteria}</td>
                  {/* <td colSpan="2" >{formCAMValues.dp_bankingcriteria_norms}</td> */}
                  <td colSpan="2">
                    {Number(formCAMValues.dp_bankingcriteria_norms) === 1 ? "Met" :
                    Number(formCAMValues.dp_bankingcriteria_norms) === 2 ? "Not Met" :
                    Number(formCAMValues.dp_bankingcriteria_norms) === 3 ? "NA" :
                    formCAMValues.dp_bankingcriteria_norms || "Not Available"}
                  </td>

                  <td colSpan="3" ><b>Banking Norms Not Met</b> </td>
                  <td colSpan="2" >{formCAMValues.dp_bankingcriteria_deviation_approval}</td>
                  <td colSpan="2" >{formCAMValues.dp_bankingcriteria_mitigation}</td>
                </tr>   

                 <tr>
                  <td colSpan="3" data-f-bold="true"><b>GST Criteria</b> </td>
                  <td colSpan="2">{formCAMValues.dp_gstcriteria_standard_criteria}</td>
                  {/* <td colSpan="2" >{formCAMValues.dp_gstcriteria_norms}</td> */}
                  <td colSpan="2">
                    {Number(formCAMValues.dp_gstcriteria_norms) === 1 ? "Met" :
                    Number(formCAMValues.dp_gstcriteria_norms) === 2 ? "Not Met" :
                    Number(formCAMValues.dp_gstcriteria_norms) === 3 ? "NA" :
                    formCAMValues.dp_gstcriteria_norms || "Not Available"}
                  </td>

                  <td colSpan="3" ><b>GST Norms Not Met</b> </td>
                  <td colSpan="2" >{formCAMValues.dp_gstcriteria_deviation_approval}</td>
                  <td colSpan="2" >{formCAMValues.dp_gstcriteria_mitigation}</td>
                </tr>   

                 <tr>
                  <td colSpan="3" data-f-bold="true"><b>Financial Criteria</b> </td>
                  <td colSpan="2">{formCAMValues.dp_financialcriteria_standard_criteria}</td>
                  {/* <td colSpan="2" >{formCAMValues.dp_financialcriteria_norms}</td> */}
                  <td colSpan="2">
                    {Number(formCAMValues.dp_financialcriteria_norms) === 1 ? "Met" :
                    Number(formCAMValues.dp_financialcriteria_norms) === 2 ? "Not Met" :
                    Number(formCAMValues.dp_financialcriteria_norms) === 3 ? "NA" :
                    formCAMValues.dp_financialcriteria_norms || "Not Available"}
                  </td>

                  <td colSpan="3" ><b>Financial Norms Not Met</b> </td>
                  <td colSpan="2" >{formCAMValues.dp_financialcriteria_deviation_approval}</td>
                  <td colSpan="2" >{formCAMValues.dp_financialcriteria_mitigation}</td>
                </tr>   

                 <tr>
                  <td colSpan="3" data-f-bold="true"><b>Additional Checks for Strategic Customer</b> </td>
                  <td colSpan="2">{formCAMValues.dp_acfsc_standard_criteria}</td>
                  {/* <td colSpan="2" >{formCAMValues.dp_acfsc_norms}</td> */}
                  <td colSpan="2">
                    {Number(formCAMValues.dp_acfsc_norms) === 1 ? "Met" :
                    Number(formCAMValues.dp_acfsc_norms) === 2 ? "Not Met" :
                    Number(formCAMValues.dp_acfsc_norms) === 3 ? "NA" :
                    formCAMValues.dp_acfsc_norms || "Not Available"}
                  </td>
                  <td colSpan="3" ><b>Any other deviations</b> </td>
                  <td colSpan="2" >{formCAMValues.dp_acfsc_deviation_approval}</td>
                  <td colSpan="2" >{formCAMValues.dp_acfsc_mitigation}</td>
                </tr>       
              </tbody>  
            </table>

        </div>
      </div>
    </>
  );
}


function mapStateToProps(state) {
  return {
    usersData: state.usersData,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign(userActions.default, leadBankStatementActions.default, leadActions.default), dispatch),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(CustomerAssessmentNoteViewPage);